/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/performance_events-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/performance_events-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/performance_events-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-performance_events-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/performance_events.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-09-17T23:32:24.818Z
 * Source config: config/entities/performance_events-entity-config.ts
 * Public fields: 16/16 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const PerformanceEventsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  performance_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // performance_id field
  event_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // event_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
  max_contestants: Type.Union([Type.Number(), Type.Null()]), // max_contestants field
  slack_run_status: Type.String(), // slack_run_status field
  slack_run_decided_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // slack_run_decided_at field
  slack_run_decided_by: Type.Union([Type.String(), Type.Null()]), // slack_run_decided_by field
  slack_no_run_target_performance_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // slack_no_run_target_performance_id field
  slack_run_notes: Type.Union([Type.String(), Type.Null()]), // slack_run_notes field
  is_scoring_published_live: Type.Boolean(), // is_scoring_published_live field
  scoring_published_live_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // scoring_published_live_at field
  scoring_published_live_by: Type.Union([Type.String(), Type.Null()]), // scoring_published_live_by field
});

export const CreatePerformanceEventsSchema = Type.Object({
  performance_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // performance_id field
  event_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // event_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  max_contestants: Type.Union([Type.Number(), Type.Null()]), // max_contestants field
  slack_run_status: Type.Optional(Type.String()), // slack_run_status field
  slack_run_decided_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // slack_run_decided_at field
  slack_run_decided_by: Type.Union([Type.String(), Type.Null()]), // slack_run_decided_by field
  slack_no_run_target_performance_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // slack_no_run_target_performance_id field
  slack_run_notes: Type.Union([Type.String(), Type.Null()]), // slack_run_notes field
  is_scoring_published_live: Type.Optional(Type.Boolean()), // is_scoring_published_live field
  scoring_published_live_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // scoring_published_live_at field
  scoring_published_live_by: Type.Union([Type.String(), Type.Null()]), // scoring_published_live_by field
});

export const UpdatePerformanceEventsSchema = Type.Object({
  performance_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // performance_id field
  event_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // event_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  max_contestants: Type.Union([Type.Number(), Type.Null()]), // max_contestants field
  slack_run_status: Type.String(), // slack_run_status field
  slack_run_decided_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // slack_run_decided_at field
  slack_run_decided_by: Type.Union([Type.String(), Type.Null()]), // slack_run_decided_by field
  slack_no_run_target_performance_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // slack_no_run_target_performance_id field
  slack_run_notes: Type.Union([Type.String(), Type.Null()]), // slack_run_notes field
  is_scoring_published_live: Type.Boolean(), // is_scoring_published_live field
  scoring_published_live_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // scoring_published_live_at field
  scoring_published_live_by: Type.Union([Type.String(), Type.Null()]), // scoring_published_live_by field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type PerformanceEventsRow = Static<typeof PerformanceEventsSchema>;
export type PerformanceEventsInsert = Static<typeof CreatePerformanceEventsSchema>;
export type PerformanceEventsUpdate = Static<typeof UpdatePerformanceEventsSchema>;

// Legacy type aliases for backward compatibility
export type PerformanceEvents = PerformanceEventsRow;
export type CreatePerformanceEvents = PerformanceEventsInsert;
export type UpdatePerformanceEvents = Static<typeof UpdatePerformanceEventsSchema>;

// Field configuration metadata
export const PerformanceEventsFieldConfig = {
  filterable: ['id', 'performance_id', 'event_id', 'slack_no_run_target_performance_id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'slack_run_status', 'is_scoring_published_live'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;
